export default "__VITE_ASSET__CAF6uU6h__"